import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface DropboxFile {
  id: string;
  name: string;
  type: 'folder' | 'file';
  path_display: string;
  size?: number;
  client_modified?: string;
  server_modified?: string;
  content_hash?: string;
  is_downloadable?: boolean;
  read_only?: boolean;
  shared_folder_id?: string | null;
  children?: DropboxFile[];
}

export interface DropboxListData {
  tree: DropboxFile[];
  summary: {
    totalFiles: number;
    totalFolders: number;
    totalEntries: number;
  };
}

export interface DropboxListResponse {
  success: boolean;
  code: number;
  data: DropboxListData;
}

export interface DropboxUploadFolderRequest {
  access_token: string;
  folder_id: string;
  ai_performance_level: string;
  file_processing_type: string;
  documentStore_id: string;
}

export interface DropboxUploadFolderResponse {
  success: boolean;
  code: number;
  message?: string;
}

class DropboxService {
  // GET: Initiate Dropbox authorization
  async authorize() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.DROPBOX.AUTH);
      return response;
    } catch (error) {
      console.error('Error authorizing Dropbox:', error);
      throw error;
    }
  }

  // POST: List files from Dropbox
  async listFiles(accessToken: string): Promise<DropboxListResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.DROPBOX.LIST_FILES,
        { access_token: accessToken }
      );
      return response.data;
    } catch (error) {
      console.error('Error listing Dropbox files:', error);
      throw error;
    }
  }

  // PUT: Upload folder from Dropbox with processing
  async uploadFolder(data: any): Promise<DropboxUploadFolderResponse> {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.DROPBOX.UPLOAD_FOLDER,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading Dropbox folder:', error);
      throw error;
    }
  }

  // LocalStorage helpers
  static saveToken(token: string) {
    localStorage.setItem('dropbox_token', token);
  }

  static getToken(): string | null {
    return localStorage.getItem('dropbox_token');
  }

  static removeToken() {
    localStorage.removeItem('dropbox_token');
  }
}

export const dropboxService = new DropboxService();
export default dropboxService;
